<template>
  <div>
    <h2 v-lang.membership></h2>
  </div>
</template>

<script>
export default {
  name: 'ViewListMember'
}
</script>



// WEBPACK FOOTER //
// src/components/view/Member/List.vue